import { combineReducers } from 'redux';

import loadPostbackSettingsError from './loadPostbackSettingsError';
import editPostbackSettingsError from './editPostbackSettingsError';
import testPostbackSettingsError from './testPostbackSettingsError';

export default combineReducers({
  loadPostbackSettingsError,
  editPostbackSettingsError,
  testPostbackSettingsError,
});
